import { render, staticRenderFns } from "./marcas.vue?vue&type=template&id=0c0ed557&scoped=true&"
import script from "./marcas.vue?vue&type=script&lang=js&"
export * from "./marcas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0ed557",
  null
  
)

export default component.exports